import { AuthActions } from "../LoginRedux/Action";
import { MissingMedDashActions } from "./action";

let cancelOrderState = {
  missingMedDashboardData: null,
  missingMedDashboardError: null,
  fetchMissingMedData: null,
  fetchMissingMedError: null,
};

export const missingMedDashReducer = (
  state = cancelOrderState,
  { type, payload }
) => {
  switch (type) {
    case MissingMedDashActions.MISSING_MED_DASHBOARD_SUCCESS:
      return {
        ...state,
        missingMedDashboardData: payload,
        missingMedDashboardError: null,
      };

    case MissingMedDashActions.MISSING_MED_DASHBOARD_FAILURE:
      return {
        ...state,
        missingMedDashboardData: null,
        missingMedDashboardError: payload,
      };
    case MissingMedDashActions.FETCH_MISSING_MED_SUCCESS:
      return {
        ...state,
        fetchMissingMedData: payload,
        fetchMissingMedError: null,
      };

    case MissingMedDashActions.FETCH_MISSING_MED_FAILURE:
      return {
        ...state,
        fetchMissingMedData: null,
        fetchMissingMedError: payload,
      };

    default:
      return state;
  }
};
